import React, { useState, useEffect, useContext } from "react";
import { Sidebar, Footer } from "./index.js";
import { getProfile } from "../utils/api";
import { useLocalStorage } from "../hooks";
import { UserContext } from "../context/UserContext";
import { useTranslation } from "react-i18next";
import LoadingIcon from "./LoadingIcon";

const ContainerDiv = ({ children }) => {
  const [accessToken, setAccessToken] = useLocalStorage("accessToken", null);
  const [refreshToken, setRefreshToken] = useLocalStorage("refreshToken", null);
  const [isFetchingProfile, setIsFetchingProfile] = useState(false);
  const { userData, setUser } = useContext(UserContext);

  // const { i18n } = useTranslation();

  useState(() => {
    const fetchProfile = async () => {
      setIsFetchingProfile(true);
      try {
        const res = await getProfile(accessToken);
        const data = res?.data;
        console.log({ data });
        if (data && data.data) {
          console.log("FETCHING PROFILE");
          setUser(data.data);
          //Fetch translations from the server
          // Add translation data to i18next
          // Object.keys(translations).forEach(lang => {
          //   i18n.addResources(lang, 'translation', translations[lang]);
          // });
          // Set the language for i18next
          // await i18n.changeLanguage('en');

          //sample language json

          // {
          //   "welcome": "Welcome",
          //   "description": "This is a description",
          //   "home": {
          //     "title": "Home Page",
          //     "content": {
          //       "intro": "Welcome to the Home Page",
          //       "body": "This is the body of the home page."
          //     }
          //   },
          //   "profile": {
          //     "greeting": "Hello, {{name}}",
          //     "details": {
          //       "age": "Age: {{age}}",
          //       "location": "Location: {{location}}"
          //     }
          //   }
          // }
          //         return (
          //   <div>
          //     <h1>{t('welcome')}</h1>
          //     <p>{t('description')}</p>
          //     <h2>{t('home.title')}</h2>
          //     <p>{t('home.content.intro')}</p>
          //     <p>{t('home.content.body')}</p>
          //     <h2>{t('profile.greeting', { name: 'John' })}</h2>
          //     <p>{t('profile.details.age', { age: 30 })}</p>
          //     <p>{t('profile.details.location', { location: 'New York' })}</p>
          //   </div>
          // );
        }
        setIsFetchingProfile(false);
      } catch (err) {
        console.log({ err });
      }
    };

    if (userData === null && !isFetchingProfile) {
      fetchProfile();
    }
  }, []);

  return (
    <div>
      {isFetchingProfile ? (
        <LoadingIcon height="200px" classname="absolute h-full" />
      ) : (
        <>{children}</>
      )}
    </div>
  );
};

export default ContainerDiv;
